export default __webpack_public_path__ + "static/media/SearchIconBlue.0d3491cc.svg";